import { Link } from "react-router-dom";
import logoNew from "../../../assets/logo-new.png";

const CoTraderDemoTopBar = ({ isDark = false }) => {
  const theme = isDark
    ? {
        border: "#1E2642",
        text: "#E8ECF8",
        surface: "#0F1424",
        button: "#4C7DFF",
      }
    : {
        border: "#E5EAF1",
        text: "#0B1220",
        surface: "#FFFFFF",
        button: "#0D6EFD",
      };

  return (
    <div className="px-3 pt-3 pb-2">
      <div
        className="d-flex align-items-center justify-content-between gap-3 flex-wrap pb-3"
        style={{
          borderBottom: `1px solid ${theme.border}`,
        }}
      >
        <div className="d-flex align-items-center">
          <img
            src={logoNew}
            alt="EMALPHA"
            loading="lazy"
            style={{ height: 30, width: "auto", objectFit: "contain" }}
          />
        </div>

        <div className="d-flex align-items-center gap-2">
          <Link
            to="/signup"
            className="rounded-pill px-3 py-2"
            style={{
              background: theme.button,
              color: "#FFFFFF",
              fontWeight: 700,
              fontSize: "0.88rem",
              textDecoration: "none",
              whiteSpace: "nowrap",
            }}
          >
            Sign up
          </Link>
          <Link
            to="/login"
            className="rounded-pill px-3 py-2"
            style={{
              border: `1px solid ${theme.border}`,
              background: theme.surface,
              color: theme.text,
              fontWeight: 700,
              fontSize: "0.88rem",
              textDecoration: "none",
              whiteSpace: "nowrap",
            }}
          >
            Login
          </Link>
        </div>
      </div>

      <div className="pt-3">
        <div
          style={{
            color: theme.text,
            fontWeight: 700,
            fontSize: "1.5rem",
            letterSpacing: "-0.02em",
          }}
        >
          CoTrader
        </div>
      </div>
    </div>
  );
};

export default CoTraderDemoTopBar;
